import React, { useEffect, useState } from "react";

const Contact = ({ data }) => {
  const [copied, setCopied] = useState(false);

  const address = data?.address || {};
  const city = address.city || "";
  const state = address.state || "";
  const phone = data?.phone || "";
  const email = data?.email || "";
  const contactMessage =
    data?.contactmessage || "Want to get in touch? Send me a message.";
  const social = Array.isArray(data?.social) ? data.social : [];
  const linkedin = social.find((s) => s.name?.toLowerCase() === "linkedin");
  const github = social.find((s) => s.name?.toLowerCase() === "github");

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
    } catch {
      // Clipboard is unavailable over http or when the user has denied it —
      // the mailto button beside this still works, so stay quiet.
      setCopied(false);
    }
  };

  if (!data) {
    return (
      <section id="contact">
        <div className="row section-head">
          <div className="twelve columns contact-head">
            <h1>
              <span>Get In Touch.</span>
            </h1>
            <p className="lead">
              Contact info is not available right now. Please try again later.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact">
      <div className="row section-head">
        <div className="twelve columns contact-head">
          <h1>
            <span>Get In Touch.</span>
          </h1>
          <p className="lead">{contactMessage}</p>
        </div>
      </div>

      <div className="row">
        <div className="twelve columns">
          <div className="contact-panel">
            {email ? (
              <div className="contact-primary">
                <span className="contact-label">Email</span>
                <a className="contact-email" href={`mailto:${email}`}>
                  {email}
                </a>
                <div className="contact-actions">
                  <a className="button contact-cta" href={`mailto:${email}`}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                    Email me
                  </a>
                  <button
                    type="button"
                    className="button button-secondary contact-copy"
                    onClick={copyEmail}
                  >
                    <i
                      className={copied ? "fa fa-check" : "fa fa-clipboard"}
                      aria-hidden="true"
                    ></i>
                    {copied ? "Copied" : "Copy address"}
                  </button>
                </div>
                <span className="contact-copy-status" role="status" aria-live="polite">
                  {copied ? `${email} copied to clipboard` : ""}
                </span>
              </div>
            ) : null}

            <dl className="contact-facts">
              {(city || state) && (
                <div className="contact-fact">
                  <dt>Based</dt>
                  <dd>{[city, state].filter(Boolean).join(", ")}</dd>
                </div>
              )}
              {phone && (
                <div className="contact-fact">
                  <dt>Phone</dt>
                  <dd>
                    <a href={`tel:${phone.replace(/\s+/g, "")}`}>{phone}</a>
                  </dd>
                </div>
              )}
              <div className="contact-fact">
                <dt>Elsewhere</dt>
                <dd className="contact-elsewhere">
                  {linkedin?.url ? (
                    <a href={linkedin.url} target="_blank" rel="noreferrer">
                      LinkedIn
                    </a>
                  ) : null}
                  {github?.url ? (
                    <a href={github.url} target="_blank" rel="noreferrer">
                      GitHub
                    </a>
                  ) : null}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
